
import React,{useState} from 'react';
import { Nav, Navbar, NavDropdown, Form, FormControl, Button, ButtonGroup, InputGroup, Modal, Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe,faHome, faPhoneSquare, faPlus, faPencilAlt, faTrash} from "@fortawesome/free-solid-svg-icons";
import { faLine, faFacebookSquare, faInstagramSquare, faTwitterSquare } from '@fortawesome/free-brands-svg-icons'

import {noImage} from '../config/projectConfig'

// export default Form1;
// // export default SideBar;
// export {
//   LabelTextInput
//   // , SideBar
//   }

export const TextInput = ( props ) => {
  const name = props.name;
  const value = props.value;
  const event = props.event;
  const index = props.index;
  const placeholder = props.placeholder;
  return (
    <FormControl name={name} value={value && value[name] ? value[name] : ''} 
      onChange={e => {event(name, e.target.value, index)} } placeholder={placeholder} required="true"/>
  )
}

// <LabelTextInput as={Row} label="Email"placeholder="example : contact@upbrand.asia" name="phone" value={doc} event={docChange} />
export const LabelTextInput = ( props ) => {
  const label = props.label;
  const labelLenght = props.labelLenght == null ? 2 :props.labelLenght;
  const as = props.as;
  const name = props.name;
  const value = props.value;
  const event = props.event;
  const index = props.index;
  const placeholder = props.placeholder;
  return (
    <Form.Group as={as} >
        <Form.Label column sm={labelLenght}> {label} </Form.Label>
        <Col sm={12-labelLenght}>
            <TextInput name={name} value={value} event={event} index={index} placeholder={placeholder} />
        </Col>
    </Form.Group>
  )
}



export const ImageInput = ( props ) => {
  const name = props.name;
  const value = props.value;
  const event = props.event;
  const path = props.path;
  const index = props.index;
  return (
    <label htmlFor={name} >
      { console.log("ImageInput("+name+","+value+","+index+","+path+")") }
      {/* {value && value[name] ? value[name] : noImage } */}
      <span style={{position:"absolute", color:"FF0"}} className="btn btn-sm btn-warning" ><a className="btn btn-primany"> <FontAwesomeIcon icon={faPencilAlt} /> </a></span>
      <img src={value && value[name] ? value[name] : noImage } style={{position:"relative"}} alt="Uploaded Images" style={{maxHeight:"200px",maxWidth:"200px"}} />
      <input id={name} type="file" className="btn btn-primany" style={{ display: "none" }} 
        onChange={ e => e.target.files[0] ? event(name, e.target.files[0], index, path) : ""} />
    </label>
  )
}
// <LabelImageInput as={Row} label="Company Logo" name="companyLogo" path="images" value={doc} event={handleUploadImage} />
export const LabelImageInput = ( props ) => {
  const label = props.label;
  const labelLenght = props.labelLenght == null ? 2 :props.labelLenght;
  const as = props.as;
  const name = props.name;
  const value = props.value;
  const event = props.event;
  const index = props.index;
  const path = props.path;
  return (
    <Form.Group as={as} >
        <Form.Label column sm={labelLenght}> {label} </Form.Label>
        <Col sm={12-labelLenght}>
            <ImageInput name={name} value={value} event={event} index={index} path={path} />
        </Col>
    </Form.Group>
  )
}




